import axios from 'axios';

// Reusable Function to create Instance
const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL: baseURL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Request Interceptor: Prathi request ki token add chestundhi
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('access_token'); // localStorage nundi token tiskuntundi
      if (token) {
        config.headers.Authorization = `Bearer ${token}`; // Header lo set chestundhi
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};

// Exports
export const rootApi = createAxiosInstance("https://wusz2t0wzk.execute-api.ap-south-1.amazonaws.com/api");
// export const senvraApi = createAxiosInstance("https://senvrabackend.onrender.com/api");
export const senvraApi= createAxiosInstance("https://wusz2t0wzk.execute-api.ap-south-1.amazonaws.com/api")